var render = function render() {
  var _setup$currentFacets, _setup$currentPaginat, _setup$pagination, _setup$pagination$pro, _setup$pagination2, _setup$pagination2$re, _setup$pagination3, _setup$pagination3$ad;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c(_setup.ProductCardSkeleton, {
    staticClass: "visually-hidden",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "header__title",
    domProps: {
      "innerHTML": _vm._s(_setup.headerTitle)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _setup.itemCount > 0,
      expression: "itemCount > 0"
    }],
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_setup$currentFacets = _setup.currentFacets) === null || _setup$currentFacets === void 0 ? void 0 : _setup$currentFacets.length,
      expression: "currentFacets?.length"
    }]
  }, [_c('ClientOnly', [_c(_setup.AzSidebar, {
    ref: "sidebar",
    staticClass: "mobile-only",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.$t('filters.title')))];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c(_setup.SearchFiltersOrganism, {
          attrs: {
            "available-facets": _setup.currentFacets,
            "sorting": _setup.currentSorting
          },
          on: {
            "sort": _setup.closeSidebar
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_c(_setup.AzButton, {
          staticClass: "sidebar-footer__button",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": _setup.onClearFilters
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$t('filters.clear')) + "\n              ")]), _vm._v(" "), _c(_setup.AzButton, {
          staticClass: "sidebar-footer__button",
          on: {
            "click": _setup.closeSidebar
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$tc('filters.apply', _setup.itemCount, {
          count: _setup.itemCount
        })) + "\n              ")])];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c(_setup.SearchFiltersOrganism, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_setup$currentPaginat = _setup.currentPagination) === null || _setup$currentPaginat === void 0 ? void 0 : _setup$currentPaginat.count) > 0,
      expression: "currentPagination?.count > 0"
    }],
    staticClass: "desktop-only",
    attrs: {
      "available-facets": _setup.currentFacets
    },
    on: {
      "sort": _setup.closeSidebar
    }
  })], 1)]), _vm._v(" "), _c(_setup.AzTabs, _vm._b({
    staticClass: "search__tabs",
    on: {
      "input": function input($event) {
        return _setup.setActiveTab($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        var _setup$currentPaginat2;
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((_setup$currentPaginat2 = _setup.currentPagination) === null || _setup$currentPaginat2 === void 0 ? void 0 : _setup$currentPaginat2.count) > 0,
            expression: "currentPagination?.count > 0"
          }]
        }, [_c('ClientOnly', [_setup.isMobile && _setup.currentFacets.length ? _c(_setup.MobileFiltersButton, {
          staticClass: "mobile-filters-button",
          on: {
            "click": _setup.openSidebar
          }
        }) : _vm._e()], 1), _vm._v(" "), !_setup.isMobile ? _c('div', {
          staticClass: "navbar"
        }, [_c(_setup.CategoryPageHeader, {
          attrs: {
            "pagination": _setup.currentPagination,
            "sorting": _setup.currentSorting
          },
          on: {
            "change-sort": function changeSort($event) {
              return _setup.changeSort($event);
            }
          }
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        var _setup$currentPaginat3, _setup$currentPaginat4, _setup$currentPaginat5;
        return [_c(_setup.AzPagination, {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((_setup$currentPaginat3 = _setup.currentPagination) === null || _setup$currentPaginat3 === void 0 ? void 0 : _setup$currentPaginat3.pages) > 1 && !_setup.isWaiting('search'),
            expression: "currentPagination?.pages > 1 && !isWaiting('search')"
          }],
          staticClass: "search__pagination",
          attrs: {
            "current": (_setup$currentPaginat4 = _setup.currentPagination) === null || _setup$currentPaginat4 === void 0 ? void 0 : _setup$currentPaginat4.current,
            "number-of-pages": (_setup$currentPaginat5 = _setup.currentPagination) === null || _setup$currentPaginat5 === void 0 ? void 0 : _setup$currentPaginat5.pages,
            "param-names-to-keep": _setup.filteredParamNames,
            "sort": _setup.selectedSort
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _setup.activeTab,
      callback: function callback($$v) {
        _setup.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, 'AzTabs', {
    'data-label-products': _setup.tabLabels.products,
    'data-label-recipes': _setup.tabLabels.recipes,
    'data-label-advices': _setup.tabLabels.advices
  }, false), [_vm._v(" "), _c(_setup.AzTab, {
    attrs: {
      "id": "products",
      "label": _vm.$t('search.resultsProducts')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _setup.isWaiting('search'),
      expression: "isWaiting('search')"
    }],
    staticClass: "search__product-skeletons"
  }, _vm._l(9, function (count) {
    return _c(_setup.ProductCardSkeleton, {
      key: "product-skeletton-".concat(count),
      attrs: {
        "width": "100%"
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_setup.isWaiting('search'),
      expression: "!isWaiting('search')"
    }],
    staticClass: "search__product-results"
  }, _vm._l(_setup.searchResults.products, function (product, index) {
    return _c(_setup.ProductCardOrganism, {
      key: product._slug,
      attrs: {
        "product": product,
        "product-index": index,
        "image-loading": index < 4 ? 'eager' : 'lazy'
      }
    });
  }), 1), _vm._v(" "), _c(_setup.SearchResultsEmpty, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_setup$pagination = _setup.pagination) !== null && _setup$pagination !== void 0 && (_setup$pagination$pro = _setup$pagination.products) !== null && _setup$pagination$pro !== void 0 && _setup$pagination$pro.count),
      expression: "!pagination?.products?.count"
    }],
    attrs: {
      "term": _vm.$t('search.resultsProducts')
    }
  })], 1), _vm._v(" "), _c(_setup.AzTab, {
    attrs: {
      "id": "recipes",
      "label": _vm.$t('search.resultsRecipes')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _setup.isWaiting('search'),
      expression: "isWaiting('search')"
    }],
    staticClass: "search__product-skeletons"
  }, _vm._l(9, function (count) {
    return _c(_setup.ProductCardSkeleton, {
      key: "recipe-skeletton-".concat(count),
      attrs: {
        "width": "100%"
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_setup.isWaiting('search'),
      expression: "!isWaiting('search')"
    }],
    staticClass: "search__results"
  }, _vm._l(_setup.searchResults.recipes, function (recipe, index) {
    return _c(_setup.AzRecipeCard, {
      key: recipe.url,
      attrs: {
        "title": recipe.title,
        "slug": recipe.url,
        "cover": recipe.photo,
        "category": recipe.category,
        "rating": recipe.rating,
        "num-reviews": recipe.numReviews,
        "wishlisted": _setup.isInRecipesWishlists(recipe.recipeId),
        "image-loading": index < 4 ? 'eager' : 'lazy'
      },
      on: {
        "click:wishlist": function clickWishlist($event) {
          return _setup.updateRecipeWishlist(recipe);
        }
      }
    });
  }), 1), _vm._v(" "), _c(_setup.SearchResultsEmpty, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_setup$pagination2 = _setup.pagination) !== null && _setup$pagination2 !== void 0 && (_setup$pagination2$re = _setup$pagination2.recipes) !== null && _setup$pagination2$re !== void 0 && _setup$pagination2$re.count),
      expression: "!pagination?.recipes?.count"
    }],
    attrs: {
      "term": _vm.$t('search.resultsRecipes')
    }
  })], 1), _vm._v(" "), _c(_setup.AzTab, {
    attrs: {
      "id": "advices",
      "label": _vm.$t('search.resultsAdvices')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _setup.isWaiting('search'),
      expression: "isWaiting('search')"
    }],
    staticClass: "search__product-skeletons"
  }, _vm._l(9, function (count) {
    return _c(_setup.ProductCardSkeleton, {
      key: "advice-skeletton-".concat(count),
      attrs: {
        "id": "advice-skeletton-".concat(count),
        "width": "100%"
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_setup.isWaiting('search'),
      expression: "!isWaiting('search')"
    }],
    staticClass: "search__results"
  }, _vm._l(_setup.searchResults.advices, function (advice, index) {
    return _c(_setup.AzAdviceCard, {
      key: advice.url,
      attrs: {
        "title": advice.title,
        "slug": advice.url,
        "cover": advice.photo,
        "category": advice.category,
        "image-loading": index < 4 ? 'eager' : 'lazy'
      }
    });
  }), 1), _vm._v(" "), _c(_setup.SearchResultsEmpty, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_setup$pagination3 = _setup.pagination) !== null && _setup$pagination3 !== void 0 && (_setup$pagination3$ad = _setup$pagination3.advices) !== null && _setup$pagination3$ad !== void 0 && _setup$pagination3$ad.count),
      expression: "!pagination?.advices?.count"
    }],
    attrs: {
      "term": _vm.$t('search.resultsAdvices')
    }
  })], 1)], 1)], 1), _vm._v(" "), _c(_setup.SearchUpsell, {
    staticClass: "search__upsell",
    attrs: {
      "kind": _setup.activeTab
    }
  }), _vm._v(" "), _c(_setup.AzBackToTopButton)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };